const YouTubeThumbnail = ({ videoUrl }) => {
    const videoId = videoUrl.split("v=")[1];
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;
  return (
      <div className="flex flex-col justify-center items-center w-full">
          <div className="w-full max-w-[560px] px-4 sm:px-0">
              <iframe
                  className="w-full aspect-video"
                  src={embedUrl}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
              ></iframe>
          </div>
          <div className="text-gray-500 text-sm mt-2">source: youtube</div>
      </div>

  );
};

export default YouTubeThumbnail;